import React from 'react'
import TabNav from '~/components/shared/TabNav/TabNav'
import { useIsMobile } from '~/hooks/useMediaQuery'
import ButtonContainer from '~/components/shared/TabNav/ButtonContainer'
import TabButton from '~/components/shared/TabNav/TabButton'
import { PanelContainer, TabPanel } from '~/components/shared/TabNav/index'
import { useTranslation } from '~/hooks/useTranslation'
import BenefitSection from './BenefitSection'
import ServiceCard from './ServiceCard'

const SelectTabNav = ({ services, children }) => {
  const { t } = useTranslation()
  const selectTabNav = t('select_tab_nav', { returnObjects: true })

  const earlyServices = services.early
  const midwayServices = services.midway
  const closingServices = services.closing

  const getServices = (name) => {
    if (name === 'do_now') return earlyServices
    if (name === 'do_next') return midwayServices
    if (name === 'do_later') return closingServices
    if (name === 'view_all')
      return earlyServices.concat(midwayServices, closingServices)
  }

  return (
    <TabNav defaultActiveTab={'view_all'} mobileMode="dropdown">
      <TabNavButtons />
      <PanelContainer asChild>
        {selectTabNav.map((item) => (
          <TabPanel
            key={`select-tab-panel-${item.name}`}
            name={item.name}
            asChild
          >
            <Services services={getServices(item.name)} />

            {children}
          </TabPanel>
        ))}
        <div className="min-w-[472px] overflow-hidden"></div>
      </PanelContainer>
    </TabNav>
  )
}

export default SelectTabNav

const Wrapper = ({ children }) => {
  const isMobile = useIsMobile()
  if (isMobile) return children

  return (
    <div className="relative w-full overflow-x-scroll sm:static sm:overflow-auto">
      {children}
    </div>
  )
}

const TabNavButtons = () => {
  const isMobile = useIsMobile()
  const titleClass = isMobile ? '' : 'text-sm mx-0 md:mx-0 lg:mx-0'

  const { t } = useTranslation()
  const selectTabNav = t('select_tab_nav', { returnObjects: true })

  return (
    <Wrapper>
      <ButtonContainer
        carouselWrapperClass="min-h-[4.5rem] mb-8"
        className="mb-6 flex flex-row justify-between gap-5 min-[530px]:justify-start min-[530px]:gap-10"
        buttonClass="min-w-16"
        titleClass={titleClass}
      >
        {selectTabNav.map((item) => (
          <TabButton
            key={`select-tab-nav-${item.name}`}
            name={item.name}
            text={item.text}
          />
        ))}
      </ButtonContainer>
    </Wrapper>
  )
}

const Services = ({ services }) => {
  return (
    <BenefitSection>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {services.map((service, idx) => (
          <ServiceCard key={`${service.requestType}-${idx}`} {...service} />
        ))}
      </div>
    </BenefitSection>
  )
}
